import React, { useContext, useEffect } from "react";
import { deleteItem } from "../../../../API/Portal/Portal";
import RemoveDialog from "../../../Shared/Remove/RemoveDialog";
import { getTreeItem } from "../MenuItems/MenuItemTreeView/utils";
import { GlobalContext } from "../../../../Renderers/GlobalContext";
import { useTranslation } from "react-i18next";

function DeleteMenuItemDialog({
    portalId, selectedItemIndex, menuItems,
    toggleDialog, onDelete
}) {

    const { organization } = useContext(GlobalContext).state
    const { t, i18n } = useTranslation([
        "portal/menu_items"
    ], {
        useSuspense: false
    })

    useEffect(() => {
        // i18n.changeLanguage(organization.platformLanguage)
    }, [])


    const item = getTreeItem(menuItems, selectedItemIndex);

    async function handleDelete() {
        if (selectedItemIndex.length === 1) {
            await deleteItem(portalId, item.id);
        } else {
            const splitIndex = selectedItemIndex.split("_");
            const parentMenuItem = getTreeItem(menuItems, splitIndex[0]);
            await deleteItem(portalId, parentMenuItem.id, item.id);
        }
        onDelete();
    }

    return (
        <RemoveDialog
            toggleDeleteDialog={toggleDialog}
            onDelete={handleDelete}
            Title={t("delete_dialog.title")}
            deleteButtonText={t("delete_dialog.buttons.delete_button_label")}
            cancelButtonText={t("delete_dialog.buttons.cancel_button_label")}
            message={t("delete_dialog.warning", { name: item.name })}
        />
    )
}

export default DeleteMenuItemDialog;